import { Component} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import { AuthService } from '../services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent  {

  userForm: FormGroup;
 

  constructor(private authService : AuthService,private formBuilder: FormBuilder,
    private router: Router,private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.buildForm();
    
  }

  buildForm(): void {
    this.userForm = this.formBuilder.group({
      'email': ['', [
          Validators.required,
          Validators.email
        ]
      ],
      'password': ['', [
        Validators.required
      ]
    ],
    });

    this.userForm.valueChanges.subscribe(data => this.onValueChanged(data));
    this.onValueChanged(); // reset validation messages
  }

   // Updates validation state on form changes.
   onValueChanged(data?: any) {
    if (!this.userForm) { return; }
    const form = this.userForm;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + ' ';
        }
      }
    }
  }

 formErrors = {
    'email': '',
    'password': ''
  };

  validationMessages = {
    'email': {
      'required':      'Email is required.',
      'email':         'Email must be a valid email'
    },
    'password': {
      'required':      'Password is required.'
    }
  };

  
  closeDialog() {
   // this.dialogRef.close('Pizza!');
  }

  /**
   * Login User inside Applicaiton
   */
  loginUser(loginProvider){
      if(loginProvider === 'Facebook'){
        this.facebookLogin();
      }else if(loginProvider === 'Google'){
        this.googleLogin();
      }else{
        this.emailLogin(this.userForm.value);
      }   
  }

  facebookLogin() {
    this.authService.loginUsingFacebook()
    .then(res => {
      this.onLoginSuccess(res);
  }, err => {
    this.onLoginError(err);  
  })
  }

  googleLogin(){
    this.authService.loginUsingGoogle()
    .then(res => {
      this.onLoginSuccess(res);
  }, err => {
    this.onLoginError(err);  
  })
  }



  /**
   * Login user from email and password
   * @param value email and password
   */
  emailLogin(value){
    console.log(value);
    this.authService.emailLogin(value)
    .then(res => {
        this.onLoginSuccess(res);
    }, err => {
      this.onLoginError(err);  
    })
  }

  /**
   * Log in is success notes here
   */
  onLoginSuccess(res){
    
   // this.dialogRef.close("Success");
    this.router.navigate(['home']);
  }

  /**
   * Login Is erro. Please show message to user
   */
  onLoginError(err){
    console.log(err);
    this.snackBar.open(err.message, 'Try Again', {
      duration: 5000,
    });
  }

}
